import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { ACTOR_TYPE, SelfOnboardingActor } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.actor}selfonboarding/actor`;

interface GetSelfOnboardingActorsQueryPayload {
  sellerId?: string;
  tenantId?: string;
  actorType?: ACTOR_TYPE;
}

async function getSelfOnboardingActorsQuery({
  sellerId,
  tenantId,
  actorType,
}: GetSelfOnboardingActorsQueryPayload): Promise<
  BackResponse<SelfOnboardingActor[]> | BackResponseFailure
> {
  try {
    const url = buildUrl(ENDPOINT, { sellerId, tenantId, actorType });

    const response = await apiCall<BackResponse<SelfOnboardingActor[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default getSelfOnboardingActorsQuery;
